<template>
	<div class="survey-container" ref="survey_container">
		<transition name="fade">
            <div class="nav-wrap">
                <div class="input-bar" v-if="surveyQuestions.current && (surveyAnswers['q' + surveyQuestions.current + '_answer'] || surveyQuestions.current === questions.length + 1)">
                    <input
                        ref="survey_message_input"
                        class="input"
                        type="text"
                        placeholder="Type your message here..."
                        v-model="feedback"
                        @keyup.enter="sendFeedback"
                        @focus="typing = true"
                        @blur="typing = false"
                    />
                    <a class="skip-question" @click="skipFeedback">Skip feedback</a>
                </div>
            </div>
        </transition>
		<span class="overlay" :class="{ active: (isMenuOpen || surveyQuestions.current && (surveyAnswers['q' + surveyQuestions.current + '_answer'] || surveyQuestions.current === questions.length + 1)) && !surveyQuestions['q' + (questions.length + 1) + '_question'] }"></span>
		<div class="header header-standard">
			<HeaderNavBar back survey />
		</div><!-- header -->
		<div class="header-image lblue"></div><!-- header image -->
		<div class="content-wrap content-wrap-alt content-wrap-nav survey-bg">
			<div class="has-split">
				<SectionTitle
					icon="ShipIcon"
					title="Happy at Sea"
					colour="lblue x"
				/>
				<img width="90" class="shi-logo" alt="The Seafarers Happiness Index" src="@/assets/shi-logo.png" />
			</div>
			<div class="chat-window">
				<div class="chat-wrap">
					<div id="messages" class="chat-date-wrap">
                        <transition name="fade">
                            <div class="chat-row" v-if="surveyQuestions.intro">
                                <div class="chat-bubble-wrap">
                                    <div class="chat-bubble">
                                        <p>We'd really like to hear about how you feel today. We're going to ask you ten questions. Simply click an emoji to answer, and type some text to give us more feedback if you wish. Let's get started... 😊</p>
                                    </div>
                                </div>
                            </div>
                        </transition>
	                    <div v-for="question in questions" :key="question.id">
                            <transition name="fade">
                                <div class="chat-group" v-if="surveyQuestions['q' + question.order + '_question']">
                                    <div class="chat-row">
                                        <div class="chat-bubble-wrap">
                                            <div class="chat-bubble">
                                                <p>{{ question.order > 1 ? 'Thank you. ' : '' }}Question {{ question.order }}: {{ question.question }}</p>
                                            </div>
                                            <span class="time" :class="{ 'time-green': surveyQuestions.current === question.order }">{{ surveyQuestions.current === question.order ? '● ' : '' }}{{ new Date | moment('HH:mm') }}</span>
                                        </div>
                                    </div>
                                </div>
                            </transition>
                            <transition name="fade">
                                <div class="chat-group sent" v-if="surveyQuestions['q' + question.order + '_answers']">
                                    <div class="chat-row">
                                        <div class="chat-bubble-wrap">
                                            <span class="sub-chat" v-if="!surveyAnswers['q' + question.order + '_answer']">Tap to choose one:</span>
                                            <div class="smileys-selection" :class="{ 'old': surveyAnswers['q' + question.order + '_answer'] }">
                                                <input type="radio" :id="'q' + question.order + '-mood-1'" :name="'q' + question.order + '-mood'" value="1" class="radio" v-model="surveyAnswers['q' + question.order + '_answer']">
                                                <label :for="'q' + question.order + '-mood-1'" class="emoji emoji-1" :class="{ 'chosen': surveyAnswers['q' + question.order + '_answer'] === '1' }">😡</label>
                                                <input type="radio" :id="'q' + question.order + '-mood-2'" :name="'q' + question.order + '-mood'" value="3.25" class="radio" v-model="surveyAnswers['q' + question.order + '_answer']">
                                                <label :for="'q' + question.order + '-mood-2'" class="emoji emoji-2" :class="{ 'chosen': surveyAnswers['q' + question.order + '_answer'] === '3.25' }">😟</label>
                                                <input type="radio" :id="'q' + question.order + '-mood-3'" :name="'q' + question.order + '-mood'" value="5.5" class="radio" v-model="surveyAnswers['q' + question.order + '_answer']">
                                                <label :for="'q' + question.order + '-mood-3'" class="emoji emoji-3" :class="{ 'chosen': surveyAnswers['q' + question.order + '_answer'] === '5.5' }">😑</label>
                                                <input type="radio" :id="'q' + question.order + '-mood-4'" :name="'q' + question.order + '-mood'" value="7.75" class="radio" v-model="surveyAnswers['q' + question.order + '_answer']">
                                                <label :for="'q' + question.order + '-mood-4'" class="emoji emoji-4" :class="{ 'chosen': surveyAnswers['q' + question.order + '_answer'] === '7.75' }">😊</label>
                                                <input type="radio" :id="'q' + question.order + '-mood-5'" :name="'q' + question.order + '-mood'" value="10" class="radio" v-model="surveyAnswers['q' + question.order + '_answer']">
                                                <label :for="'q' + question.order + '-mood-5'" class="emoji emoji-5" :class="{ 'chosen': surveyAnswers['q' + question.order + '_answer'] === '10' }">😆</label>
                                            </div>
                                        </div>
                                    </div>
                                    <transition name="fade">
                                        <div class="chat-row" v-if="surveyAnswers['q' + question.order + '_feedback'] && surveyAnswers['q' + question.order + '_feedback'] !== 'Skipped'">
                                            <div class="chat-bubble-wrap">
                                                <div class="chat-bubble">
                                                    <p>{{ surveyAnswers['q' + question.order + '_feedback'] }}</p>
                                                </div>
                                                <span class="time" :class="{ 'time-green': surveyQuestions.i === question.order }">{{ surveyQuestions.i === question.order ? '● ' : '' }}{{ new Date | moment('HH:mm') }}</span>
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </transition>
                        </div>
                        <transition name="fade">
                            <div class="chat-group" v-if="surveyQuestions['q' + (questions.length + 1) + '_question']">
                                <div class="chat-row">
                                    <div class="chat-bubble-wrap">
                                        <div class="chat-bubble">
                                            <p>Thank you. Finally, is there anything else about life onboard that you’d like to tell us about? We want to hear your story.</p>
                                        </div>
                                        <span class="time" :class="{ 'time-green': surveyQuestions.i === (questions.length + 1) && surveyQuestions.current }">{{ surveyQuestions.i === (questions.length + 1) && surveyQuestions.current ? '● ' : '' }}{{ new Date | moment('HH:mm') }}</span>
                                    </div>
                                </div>
                            </div>
                        </transition>
                        <transition name="fade">
                            <div class="chat-group sent" v-if="surveyAnswers['q' + (questions.length + 1) + '_feedback'] && surveyAnswers['q' + (questions.length + 1) + '_feedback'] !== 'Skipped'">
                                <div class="chat-row">
                                    <div class="chat-bubble-wrap">
                                        <div class="chat-bubble">
                                            <p>{{ surveyAnswers['q' + (questions.length + 1) + '_feedback'] }}</p>
                                        </div>
                                        <span class="time" :class="{ 'time-green': !surveyQuestions.outro }">{{ !surveyQuestions.outro ? '● ' : '' }}{{ new Date | moment('HH:mm') }}</span>
                                    </div>
                                </div>
                            </div>
                        </transition>
                        <transition name="fade">
                            <div class="chat-group" v-if="surveyQuestions.outro">
                                <div class="chat-row">
                                    <div class="chat-bubble-wrap">
                                        <div class="chat-bubble">
                                            <p>That’s great, that’s all questions answered about life onboard...</p>
                                        </div>
                                        <span class="time" :class="{ 'time-green': surveyQuestions.outro }">{{ surveyQuestions.outro ? '● ' : '' }}{{ new Date | moment('HH:mm') }}</span>
                                    </div>
                                </div>
                            </div>
                        </transition>
					</div><!-- date wrap -->
				</div><!-- chat wrap -->
			</div>
		</div>
		<Menu />
        <div ref="survey_anchor"/>
	</div>
</template>
<script>
	import HeaderNavBar from '@/components/HeaderNavBar.vue';
	import Menu from '@/components/Menu.vue';
    import SectionTitle from '@/components/SectionTitle.vue';
    import SurveyService from '@/services/SurveyService';
    import { Capacitor } from '@capacitor/core';
    import { Keyboard, KeyboardResize } from '@capacitor/keyboard';
	export default {
		name: 'SurveyTake',
		components: {
			HeaderNavBar,
			Menu,
			SectionTitle
		},
		data () {
	        return {
	        	tabOneActive: true,
	        	tabTwoActive: false,
	        	message: '',
	        	typing: false,
	        	stickyHeader: false,
                information: {},
                messages: [],
                file: null,
                questions: [],
                surveyData: [],
                surveyQuestions: {
                    intro: false,
                    outro: false,
                    current: 0,
                    i: 0
                },
                feedback: null,
                surveyAnswers: {},
                isLoading: false,
                isKeyboardActive: false
	        };
	    },
	    methods: {
            sendFeedback () {
                this.surveyAnswers['q' + this.surveyQuestions.current + '_feedback'] = this.feedback;
                this.feedback = null;
                if (this.surveyQuestions.current === this.questions.length + 1) {
                    this.surveyData.push({
                        question: 'Final feedback',
                        feedback: this.surveyAnswers['q' + this.surveyQuestions.current + '_feedback']
                    });
                } else {
                    this.surveyData.push({
                        question: this.questions[this.surveyQuestions.current - 1].question,
                        answer: this.surveyAnswers['q' + this.surveyQuestions.current + '_answer'],
                        feedback: this.surveyAnswers['q' + this.surveyQuestions.current + '_feedback']
                    });
                }
                this.updateSurvey().then(() => {
                    if (this.surveyQuestions.current === this.questions.length + 1) {
                        this.showOutro();
                    } else {
                        this.showQuestion(this.surveyQuestions.current + 1);
                    }
                });
            },
            skipFeedback () {
                this.surveyAnswers['q' + this.surveyQuestions.current + '_feedback'] = 'Skipped';
                if (this.surveyQuestions.current === this.questions.length + 1) {
                    this.surveyData.push({
                        question: 'Final feedback',
                        feedback: this.surveyAnswers['q' + this.surveyQuestions.current + '_feedback']
                    });
                } else {
                    this.surveyData.push({
                        question: this.questions[this.surveyQuestions.current - 1].question,
                        answer: this.surveyAnswers['q' + this.surveyQuestions.current + '_answer'],
                        feedback: this.surveyAnswers['q' + this.surveyQuestions.current + '_feedback']
                    });
                }
                this.updateSurvey().then(() => {
                    if (this.surveyQuestions.current === this.questions.length + 1) {
                        this.showOutro();
                    } else {
                        this.showQuestion(this.surveyQuestions.current + 1);
                    }
                });
            },
            updateSurvey () {
                return SurveyService.updateSurvey({
                    survey_id: this.surveyId,
                    data: this.surveyData
                }).then((response) => {
                    this.$store.commit('SET_SURVEY_ID', response.data.uuid);
                });
            },
            showQuestion1 () {
                this.surveyQuestions.q1_question = false;
                this.surveyQuestions.q1_answers = false;
                setTimeout(() => {
                    this.surveyQuestions.intro = true;
                }, 1000);
                setTimeout(() => {
                    this.surveyQuestions.q1_question = true;
                }, 2000);
                setTimeout(() => {
                    this.surveyQuestions.q1_answers = true;
                    this.surveyQuestions.current = 1;
                    this.surveyQuestions.i = 1;
                }, 3000);
            },
            showQuestion (i) {
                this.surveyQuestions[`q${i}_question`] = false;
                this.surveyQuestions[`q${i}_answers`] = false;
                this.surveyQuestions.current = 0;
                setTimeout(() => {
                    this.surveyQuestions[`q${i}_question`] = true;
                }, 1000);
                setTimeout(() => {
                    this.surveyQuestions[`q${i}_answers`] = true;
                    this.surveyQuestions.current = i;
                    this.surveyQuestions.i = i;
                }, 2000);
                setTimeout(() => {
                    this.$refs.survey_anchor.scrollIntoView({ behavior: 'smooth' });
                }, 2001);
            },
            showOutro () {
                this.surveyQuestions.current = 0;
                setTimeout(() => {
                    this.surveyQuestions.outro = true;
                }, 2000);
                setTimeout(() => {
                    this.$refs.survey_anchor.scrollIntoView({ behavior: 'smooth' });
                }, 2001);
                setTimeout(() => {
                    this.isLoading = true;
                }, 3000);
                setTimeout(() => {
                    this.$router.push({ name: 'SurveyTakeFinal' });
                }, 5000);
            },
            getQuestions () {
                SurveyService.getQuestions().then((response) => {
                    this.questions = response.data;
                });
            }
        },
	    computed: {
			isMenuOpen () {
	            return this.$store.state.isMenuOpen;
	        },
            surveyId () {
                return this.$store.state.surveyId;
            }
		},
		mounted () {
            if (Capacitor.isNativePlatform()) {
                Keyboard.setAccessoryBarVisible({
                    isVisible: true
                });
                Keyboard.setResizeMode({
                    mode: KeyboardResize.Native
                });
                Keyboard.addListener('keyboardWillShow', () => {
                    this.isKeyboardActive = true;
                });
                Keyboard.addListener('keyboardWillHide', () => {
                    this.isKeyboardActive = false;
                });
            }
            this.getQuestions();
            this.showQuestion1();
        }
	};
</script>
<style scoped lang="scss">
	@import "@/assets/scss/_variables.scss";
	@mixin max_width($breakpoint) {
	    @media only screen and (max-width: $breakpoint) { @content; }
	}
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    .survey-container {
        position: relative;
    }
	.sub-chat {
		font-size: 14px;
		color: $white;
		letter-spacing: -0.41px;
		line-height: 17px;
		font-weight: 600;
		margin-bottom: 15px;
	}
	.smileys-selection .radio {
	    display: none;
	}
	.smileys-selection {
		display: flex;
    	justify-content: flex-start;
	}
	.smileys-selection.old .emoji {
		opacity: 0.25;
		pointer-events: none;
		&.chosen {
			opacity: 1;
			font-size: 35px;
			@include max_width(350px) {
				font-size: 30px;
			}
		}
	}
	.smileys-selection .emoji {
	    font-size: 28px;
	    display: inline-block;
	    cursor: pointer;
	    padding: 0;
	    border: solid 1px #fff;
	    border-radius: 100px;
	    width: 50px;
	    height: 50px;
	    text-align: center;
	    margin-right: 7px;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    line-height: 0;
	    flex-shrink: 0;
	    @include max_width(400px) {
	    	width: 45px;
	    	height: 45px;
	    	margin-right: 5px;
	    }
	    @include max_width(350px) {
	    	width: 40px;
	    	height: 40px;
	    	font-size: 25px;
	    }
	}
	.survey-bg {
		background: #2F92DF;
		//min-height: 710px;
        min-height: 100vh;
	}
	.section-title.lblue.x h1 {
		color: $white;
	}
	.has-split {
		display: flex;
		justify-content: space-between;
		align-items: center;
		@include max_width(380px) {
			align-items: flex-start;
		}
		.shi-logo {
			margin-left: 15px;
			@include max_width(380px) {
				width: 85px;
			}
		}
	}
	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}
	.fade-enter, .fade-leave-to {
		opacity: 0;
	}
	.sticky-header {
		position: fixed;
	    top: 0;
	    z-index: 120;
	    width: 100%;
	    background: $white;
	    height: 102px;
	    box-shadow: 0px 25px 50px 0px rgba($black, 0.1);
	    padding: 40px 28px 0;
	    .sticky-inner {
	    	display: flex;
	    	align-items: center;
	    }
	    .sticky-title {
	    	font-size: 17px;
	    	letter-spacing: -0.42px;
	    	line-height: 20px;
	    	color: $dark;
	    	h3 {
	    		margin-bottom: 6px;
	    	}
	    }
	    .sticky-arrow {
	    	margin-right: 15px;
	    	svg {
	    		display: block;
	    		path, g {
	    			stroke-width: 3;
	    			stroke: $grey;
	    		}
	    	}
	    }
	    .icon-wrap {
	    	display: flex;
	    	align-items: center;
	    	svg {
	    		margin-right: 8px;
	    		display: block;
	    		path, g {
	    			stroke-width: 4;
	    		}
	    	}
	    	span {
	    		font-size: 14px;
	    		line-height: 17px;
	    		color: $mid;
	    	}
	    }
	}
	.information-wrap {
		padding-bottom: 50px;
		.btn-yellow-light {
			margin-bottom: 15px;
		}
		.info-card {
			padding: 25px;
			margin-bottom: 20px;
			h3 {
				color: $dark;
				font-size: 17px;
				margin-bottom: 5px;
			}
			.info-card-wrap {
				.row {
					border-bottom: none;
				}
			}
		}
	}
	.chat-window {
		padding: 28px 0 100px 0;
		// background: #2F92DF;
		.date {
			color: $grey;
			margin-bottom: 25px;
			opacity: 1;
		}
	}
	.chat-wrap {
		display: flex;
		flex-direction: column;
	}
	.chat-date-wrap {
		display: flex;
		flex-direction: column;
	}
	.chat-group {
		display: flex;
		flex-direction: column;
		margin-bottom: 18px;
		.chat-row {
			&:last-child {
				.chat-bubble {
					border-radius: 20px 20px 20px 0;
				}
				.media-bubble {
					img {
						border-radius: 20px 20px 20px 0;
					}
				}
			}
		}
		&.sent {
			.chat-row {
				justify-content: flex-end;
				&:last-child {
					.chat-bubble {
						border-radius: 20px 20px 0 20px;
					}
					.media-bubble {
						img {
							border-radius: 20px 20px 0 20px;
						}
					}
				}
				.chat-bubble-wrap {
					.time {
						text-align: right;
					}
                    .time-green {
                        color: lawngreen;
                    }
				}
				.media-bubble {
					justify-content: flex-end;
				}
				.chat-bubble {
					background: #003687;
					p {
						color: $white;
					}
				}
			}
		}
	}
	.chat-row {
		display: flex;
		text-align: left;
		margin-bottom: 18px;
		.chat-bubble-wrap {
			position: relative;
			width: 80%;
			display: flex;
			flex-direction: column;
			@include max_width(370px) {
				width: 85%;
			}
			@include max_width(350px) {
				width: 90%;
			}
			.time {
				font-size: 14px;
				letter-spacing: -0.41px;
				line-height: 17px;
				font-weight: $weight_600;
				color: $grey;
				margin-top: 8px;
			}
            .time-green {
                color: lawngreen;
            }
		}
		.media-bubble {
			display: flex;
			justify-content: flex-start;
			img {
				border-radius: 20px;
				max-width: 60%;
			}
		}
		.chat-bubble {
			padding: 18px;
			background: $white;
    		border-radius: 20px;
    		flex-shrink: 0;
			p {
				font-size: 14px;
				letter-spacing: -0.41px;
				line-height: 17px;
				font-weight: $weight_600;
				margin: 0;
				color: #475668;
			}
		}
	}
	.chat-complete {
		width: 260px;
		margin: 20px auto 50px;
		svg {
			margin-bottom: 7px;
			g, path {
				stroke: $mid;
			}
		}
		p {
			font-size: 14px;
			letter-spacing: -0.41px;
			line-height: 19px;
			font-weight: $weight_400;
			color: $mid;
			strong {
				font-weight: $weight_600;
				color: $mid;
			}
		}
	}
	.header-wrap {
		background: $sky_base;
		.header {
			position: relative;
			height: auto;
			padding-top: 70px;
		}
	}
	.request-header {
		width: 100%;
		text-align: left;
		padding-top: 30px;
		padding-bottom: 25px;
		h1 {
			font-size: 26px;
			line-height: 31px;
			letter-spacing: -0.65px;
			color: $white;
			margin-bottom: 8px;
		}
		p {
			color: $white;
		}
		.request-header-port {
			display: flex;
			align-items: center;
			svg {
				margin-right: 5px;
				g, path {
					stroke: $light;
					stroke-width: 3;
				}
			}
			span {
				color: $light;
				font-size: 14px;
				line-height: 17px;
				font-weight: $weight_600;
			}
		}
		.request-nav {
			padding-top: 30px;
			display: flex;
			a {
				display: flex;
				color: $light;
				font-size: 14px;
				line-height: 17px;
				letter-spacing: -0.35px;
				border-bottom: 4px solid transparent;
				padding-bottom: 5px;
				margin-right: 20px;
				font-weight: $weight_600;
				&.active {
					color: $white;
					border-color: $green_base;
				}
			}
		}
	}
	.nav-wrap {
	    position: fixed;
	    bottom: 0;
	    z-index: 120;
	    width: 100%;
	    background: $white;
	    .skip-question {
	    	position: relative;
	    	font-size: 14px;
	    	color: $white;
	    	letter-spacing: -0.41px;
	    	line-height: 17px;
	    	font-weight: 600;
	    	text-decoration: underline;
	    }
	    .input-bar {
	    	display: flex;
	    	align-items: center;
	    	justify-content: space-between;
	    	padding: 0 30px;
	    	height: 80px;
	    	background: #2F92DF;
	    	border-top: 1px solid #2488d5;
	    	.input {
	    		background: $snow;
	    		border-radius: 21px;
	    		border-color: $snow;
	    		box-shadow: none;
	    		height: 42px;
	    		line-height: 42px;
	    		font-size: 14px;
	    		letter-spacing: -0.21px;
	    		line-height: 17px;
	    		color: $dark;
	    		padding: 0 18px;
	    		width: calc(100% - 105px);
	    		&::placeholder {
		            color: $mid;
		        }
		        &:focus {
		        	background: $light;
		        	border-color: $light;
		        }
	    	}
	    	svg {
	    		margin-right: 15px;
	    		flex-shrink: 0;
	    		cursor: pointer;
	    		g, path, circle {
	    			stroke: $blue_base;
	    		}
	    		.fill {
	    			fill: $blue_base;
	    		}
	    		&.svg-right {
	    			margin-right: 0;
	    			margin-left: 15px;
	    			g, path, circle {
		    			stroke: $white;
		    			fill: $white;
		    		}
	    		}
	    	}
	    }
		nav {
			position: relative;
			box-shadow: none;
			border-radius: none;
		}
	}
</style>
